export const mainAdmin = {
  data() {
    return {
    }; // return DATA
  }, // DATA
  computed: {
    MainCofig() {
      return this.$store.state.config;
    },
    isOnlySales() {
      if (this.MainCofig.selectedAdminProfile == 'ventas') return true;
      if (this.MainCofig.selectedAdminProfile == 'ventasHistorial') return true;
      return false;
    }
  }, // COMPUTED
} // export default
